export default __webpack_public_path__ + "ce6b1b54b7c82a2d0a1011a8237f918e.svg";